import { createRoute, redirect, useParams } from '@tanstack/react-router';
import { Route as appRoute } from '../../../app.js';
import { useAuthStore } from '../../../../lib/auth.js';
import { canSeePrivateCourses } from '../../../../lib/capabilities.js';
import { usePrivateCourse } from '../../../../hooks/usePrivateCourses.js';
import { AdminPageHeader } from '../../../../components/admin/AdminPageHeader.js';
import { CourseForm } from '../../../../components/admin/CourseForm.js';

export const Route = createRoute({
  getParentRoute: () => appRoute,
  path: 'admin/private-courses/$courseId',
  beforeLoad: () => {
    if (!canSeePrivateCourses(useAuthStore.getState().user)) throw redirect({ to: '/app' });
  },
  component: EditPrivateCoursePage,
});

function EditPrivateCoursePage() {
  const { courseId } = useParams({ from: '/app/admin/private-courses/$courseId' });
  const { data, isLoading, error } = usePrivateCourse(courseId);

  if (isLoading) return <p className="text-muted">Loading…</p>;
  if (error)
    return (
      <p className="text-danger bg-danger-bg border border-danger/30 rounded-lg px-4 py-3">
        {(error as Error).message}
      </p>
    );
  if (!data) return null;

  return (
    <div>
      <AdminPageHeader
        title={data.course.name}
        description={`${data.course.providerName}${data.course.cricosCode ? ` · CRICOS ${data.course.cricosCode}` : ''}`}
        backTo="/app/admin/private-courses"
        backLabel="Private courses"
      />
      <CourseForm variant="private" initial={data.course} />
    </div>
  );
}
